// extracted by mini-css-extract-plugin
export default {"migrate-list":"MigrateResponsibilityOperational_migrate-list__AFIec"};